<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
</head>
<body>

<header id="headContent">
  <span class="header-title">
    {{ 'pending.pending turns' | translate }}
  </span>
  <div class="header-controls">
    <button class="action-button green-button" (click)="back()">
      <span class="button-text">
        {{ 'global.back' | translate }}
      </span>
    </button>
  </div>
</header>

<main>
  <div class="turns-list-container">
    <div *ngFor="let turn of pendingTurns; let i = index" class="turn-item">
      <div class="turn-item-header">
        <span class="turn-identifier">
          {{ 'pending.turn' | translate }} {{ turn.turn }}
        </span>
        <div class="turn-controls">
          <button class="action-button blue-button" (click)="callSelectedTurn(turn)">
            <span class="button-text"> {{ 'pending.call' | translate }}</span>
          </button>
        </div>
      </div>
      <div class="turn-item-body">
        <p>
          {{ 'pending.service' | translate }}
          <span>{{ turn.deskName }}</span>
        </p>
        <p>{{ 'pending.date' | translate }} {{ turn.turnDate | dateUnixTransformer: 'true' }}</p>
        <p *ngIf="turn.customerName || turn.customerSurname">{{ 'pending.customer' | translate }} {{ turn.customerName + ' ' + turn.customerSurname }}</p>
        <p *ngIf="turn.formName">{{ 'pending.form' | translate }} {{ turn.formName }}</p>
      </div>
    </div>
  </div>
</main>
<footer id="footer" class="content_left">
  Power by <img src="/assets/images/mturn_logo.svg" class="footer-logo" alt="mTurn Logo">
</footer>
<h5>v{{ version }}</h5>
</body>
</html>
